module.exports = __webpack_public_path__ + "static/media/mr-soty2.f2768151.png";